import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivateService } from "./activate.service";
import { Router } from "@angular/router";
import { ApiService } from '@bt/core';
import { Error } from "@bt/shared";

@Component({
    selector: 'app-activate',
    templateUrl: './activate.component.html'
})
export class ActivateComponent {
    public activationCode: string;
    public showLoader: boolean = false;
    public error: Error;

    constructor(private service: ActivateService,
        private apiService: ApiService,
        private router: Router) { }
    
    public activate(): void {
        if (!this.showLoader) {
            this.showLoader = true;

            this.apiService
                .putAnonym("api/users", {
                    code: this.activationCode,
                    sessionId: localStorage.getItem("activationSessionId")
                    // sessionId: localStorage.getItem("sessionId")
                })
                .subscribe(
                    (response) => {
                        this.router.navigateByUrl("")
                          .then(() => this.showLoader = false);
                      },
                      (error: HttpErrorResponse) => {
                        this.error = error.error;
                        this.showLoader = false;
                      }
                );
                // .toPromise()
                // .then(resp => {
                //     this.router.navigateByUrl("")
                //         .then(() => this.showLoader = false);
                // })
                // .catch((error: HttpErrorResponse) => {
                //     this.error = error.error;
                //     this.showLoader = false;
                // });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/public/activate/activate.component.ts